<template>
  <section class="facet-group">
    <button
      type="button"
      class="facet-head"
      :aria-expanded="String(open)"
      @click="$emit('toggle')"
    >
      <span class="facet-title">{{ title }}</span>
      <span v-if="selected" class="facet-selected">{{ selected }}</span>
      <span v-if="!open && total" class="facet-total">{{ total }}</span>
      <i
        class="mdi mdi-chevron-down facet-chevron"
        :class="{ 'is-open': open }"
      ></i>
    </button>
    <div v-if="open" class="facet-body">
      <slot />
    </div>
  </section>
</template>
<script>
// Un filtro de la barra lateral, plegable. Cerrado muestra cuántas opciones
// tiene; con algo elegido, cuántas hay puestas.
export default {
  name: "FacetGroup",
  props: {
    title: { type: String, required: true },
    open: { type: Boolean, default: true },
    selected: { type: Number, default: 0 },
    total: { type: Number, default: 0 }
  }
};
</script>
<style lang="scss" scoped>
.facet-group {
  border-top: 1px solid #e5e7eb;
}

.facet-head {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding: 11px 2px;
  text-align: left;

  &:hover .facet-chevron {
    color: #111827;
  }

  &:focus-visible {
    outline: 2px solid #2563eb;
    outline-offset: -2px;
    border-radius: 4px;
  }
}

.facet-title {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #111827;
}

.facet-selected {
  min-width: 18px;
  padding: 0 5px;
  border-radius: 9999px;
  background: #2563eb;
  color: white;
  font-size: 11px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
}

.facet-total {
  margin-left: auto;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 11px;
  color: #9ca3af;
}

.facet-chevron {
  margin-left: auto;
  font-size: 18px;
  line-height: 1;
  color: #9ca3af;
  transition: transform 0.15s;

  &.is-open {
    transform: rotate(180deg);
  }

  .facet-total + & {
    margin-left: 0;
  }
}

.facet-body {
  padding: 0 0 12px;
}
</style>
